// eslint-disable-next-line no-restricted-imports
import {
	environmentOptions,
	getConfigEnvironment,
	hostEnvOptions,
	nodeEnvOptions,
	projectOptions,
} from './getConfigEnvironment';

const formatOptions = (options: readonly string[]): string =>
	options.map((option) => `"${option}"`).join(', ');

function assertConfigItem<Value extends string>(
	configItem: Value | undefined,
	allowedValues: ReadonlyArray<Value>,
	message: string,
): asserts configItem is Value {
	if (!allowedValues.includes(configItem as Value)) {
		throw new Error(message);
	}
}

const configEnvironment = getConfigEnvironment();

assertConfigItem(
	configEnvironment.hostEnv,
	hostEnvOptions,
	`NEXT_PUBLIC_HOST_ENV is not defined. Please set it to ${formatOptions(hostEnvOptions)}.`,
);

assertConfigItem(
	configEnvironment.environment,
	environmentOptions,
	`NEXT_PUBLIC_ENV is not defined. Please set it to ${formatOptions(
		environmentOptions,
	)}.`,
);

assertConfigItem(
	configEnvironment.project,
	projectOptions,
	`NEXT_PUBLIC_PRJ is not defined. Please set it to ${formatOptions(projectOptions)}.`,
);

assertConfigItem(
	configEnvironment.nodeEnv,
	nodeEnvOptions,
	`NODE_ENV is not defined. Please set it to ${formatOptions(nodeEnvOptions)}.`,
);

export const { nodeEnv, hostEnv, environment, project } = configEnvironment;
